import gql from 'graphql-tag'

export const GET_ALL_WAREHOUSES = gql`
query {
  Warehouses{
    id
    name
    isActive
    location
  }
}`